import { Stack, StackProps } from '@chakra-ui/react';

export default function FilterGroup({ children, ...props }: StackProps) {
  return (
    <Stack
      w="full"
      spacing="20px"
      direction="row"
      flexWrap="wrap"
      {...props}
    >
      {children}
    </Stack>
  )
}
